export default __webpack_public_path__ + "assets/front/scss/formulaire.e1a8bf9970a00403f005fa789ea78dd5.css";